import UserProfilePortal from './UserProfilePortal'

export default UserProfilePortal